"use client";
import { useStore } from "@nanostores/react";
import clsx from "clsx";
import { type Dispatch, type ReactNode, type SetStateAction, useEffect } from "react";
import { menuStore } from "./MenuInner";
import { infoModalHeightStore } from "./infoModal/store";

type Props = {
  children: ReactNode;
  search: ReactNode;
  infoHeader: ReactNode;
  isHeaderTransparent: boolean;
  setIsHeaderTransparent: Dispatch<SetStateAction<boolean>>;
};
export const ContainerHomepage = ({
  children,
  infoHeader,
  search,
  isHeaderTransparent,
  setIsHeaderTransparent,
}: Props) => {
  const infoHeaderHeight = useStore(infoModalHeightStore);
  const openMenu = useStore(menuStore);

  useEffect(() => {
    const handleScroll = () => {
      const HEADER_HEIGHT = window.innerWidth > 1200 ? 80 : 56;
      const sticky = 650 - HEADER_HEIGHT + infoHeaderHeight;

      if (window.scrollY >= sticky) {
        setIsHeaderTransparent(false);
      } else {
        setIsHeaderTransparent(true);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [infoHeaderHeight, setIsHeaderTransparent]);

  // biome-ignore lint/correctness/useExhaustiveDependencies: <explanation>
  useEffect(() => {
    const HEADER_HEIGHT = window.innerWidth > 1200 ? 80 : 56;
    const sticky = 650 - HEADER_HEIGHT + infoHeaderHeight;

    if (window.scrollY >= sticky) {
      setIsHeaderTransparent(false);
    } else {
      setIsHeaderTransparent(true);
    }
  }, []);

  return (
    <>
      <div
        className={clsx("w-full xl:fixed xl:top-0 xl:z-21 transition-colors", {
          "bg-transparent": isHeaderTransparent,
          "bg-white": !isHeaderTransparent,
        })}
      >
        {isHeaderTransparent && (
          <>
            <div className="bg-linear-to-b from-black/50 w-full h-20 fixed top-0 left-0 max-xl:hidden" />
            <div className="[mask:linear-gradient(black,black,transparent)] w-full h-20 fixed top-0 left-0 backdrop-blur-sm max-xl:hidden" />
            <div className="bg-white/1 w-full h-20 fixed top-0 left-0 blur-xl max-xl:hidden" />
          </>
        )}
        {infoHeader}
        {children}
        {!isHeaderTransparent && openMenu === null && search}
      </div>
    </>
  );
};
